import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, ControlLabel } from 'react-bootstrap'
import HelpPopover from '../HelpPopover'

function CalculatorResult({ label, value, popover, helpText }) {
  return (
    <div className="calculator-result">
      <Row>
        <Col xs={7}>
          <ControlLabel>
            {label}
            {popover && (<HelpPopover popover={popover} />)}
          </ControlLabel>
        </Col>
        <Col xs={5} className="money">
          {value}
        </Col>
      </Row>
      {helpText && (
        <Row>
          <Col xs={12}>
            {helpText}
          </Col>
        </Row>
      )}
    </div>
  )
}

CalculatorResult.propTypes = {
  label: PropTypes.node,
  value: PropTypes.node,
  popover: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.arrayOf(PropTypes.string)
  }),
  helpText: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
}

export default CalculatorResult



// WEBPACK FOOTER //
// ./src/components/CalculatorResult/index.js